import { isJsonParsable, endpoints } from "helpers";

const {
  REACT_APP_NA_CHAT_API_URL,
  REACT_APP_EMEA_CHAT_API_URL,
  REACT_APP_LAO_CHAT_API_URL
} = process.env;
let thread_id = '';

export const streamChatApiUrls = {
  'na': process.env.REACT_APP_NA_STREAM_CHAT_API_URL,
  'emea': process.env.REACT_APP_EMEA_STREAM_CHAT_API_URL,
  'lao': process.env.REACT_APP_LAO_STREAM_CHAT_API_URL
}
export const getChatBotService = (query, region = 'NA', timeout = 90000) => {
  const options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      session_id: thread_id,
      // 'Access-Control-Allow-Origin': '',
      // withCredentials: true
      // 'Access-Control-Allow-Methods':'DELETE, POST, GET, OPTIONS',
      // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With'
    }
  };

  const apiUrls = {
    NA: REACT_APP_NA_CHAT_API_URL,
    EMEA: REACT_APP_EMEA_CHAT_API_URL,
    lao: REACT_APP_LAO_CHAT_API_URL
  }

  return fetch(
    apiUrls[region] +
    `?username=${query.username}&question=${query.question}`,
    options
  )
    .then(d => {
      if (d.status === 200) {
        return d.json();
      }
    })
    .then(d => {
      thread_id = d?.thread_id;
      return d;
    })
    .catch(err => {
      console.log(err);
      return err;
    })

  // return Promise.race([
  //   fetch(
  //     apiUrls[region] +
  //       `?username=${query.username}&question=${query.question}`,
  //     options
  //   )
  //     .then(d => {
  //       if (d.status === 200) {
  //         return d.json();
  //       }
  //     })
  //     .then(d => {
  //       thread_id = d?.thread_id;
  //       return d;
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       return err;
  //     }),
  //   new Promise((_, reject) =>
  //     setTimeout(() => reject(console.log('chat api timeout')), timeout)
  //   )
  // ]);
};


export const getStreamChatService = async ({ params, user, region = 'na', signal }) => {

  // let oktaToken = localStorage.getItem('okta-token-lisa');
  // if (oktaToken) {
  //   oktaToken = isJsonParsable(oktaToken)
  // }

  const basicToken = btoa(`${process.env.REACT_APP_LISA_BASIC_AUTH_ID}:${process.env.REACT_APP_LISA_BASIC_AUTH_PWD}`);
  const reqHeaders = new Headers();
  reqHeaders.append("Content-Type", "application/json");
  // reqHeaders.append("Authorization", `Bearer ${oktaToken?.accessToken?.accessToken}`);  
  reqHeaders.append("Authorization", `Basic ${basicToken}`);

  const reqBody = {
    "userId": user?.UserID,
    "application_id": thread_id || "",
    "query_text": params?.userInput,
    "top_k": "10",
    // "tables": ["table1", "table2"]
  }

  const requestOptions = {
    method: "POST",
    headers: reqHeaders,
    body: JSON.stringify(reqBody),
    redirect: "follow",
    mode: "cors",
    signal
  };

  return fetch(`${streamChatApiUrls[region.toLowerCase()]}${endpoints.lisa.chat}`, requestOptions)
    .then(d => {
      if ([200, 201].includes(d.status)) {
        return d.json();
      } else {
        return { data: { errorCode: d.status } };
      }
    })
    .then(d => {
      thread_id = d?.data?.application_id;
      return { ...d?.data, duration: d?.metadata?.duration };
    })
    .catch(err => {
      console.log(err);
      return err;
    })
}

export const submitFeedbackService = async ({ user, region, questionUid, feedbackText, feedbackFlag }) => {
  const basicToken = btoa(`${process.env.REACT_APP_LISA_BASIC_AUTH_ID}:${process.env.REACT_APP_LISA_BASIC_AUTH_PWD}`);
  const reqHeaders = new Headers();
  reqHeaders.append("Content-Type", "application/json");
  // reqHeaders.append("Authorization", `Bearer ${oktaToken?.accessToken?.accessToken}`);  
  reqHeaders.append("Authorization", `Basic ${basicToken}`);

  const reqBody = {
    "question_uid": questionUid,
    "feedback_text": feedbackText,
    "feedback_flag": feedbackFlag,
    "application_id": thread_id || "",
    "userId": user?.UserID,
  }

  const requestOptions = {
    method: "POST",
    headers: reqHeaders,
    body: JSON.stringify(reqBody),
    redirect: "follow",
    mode: "cors"
  };

  return fetch(`${streamChatApiUrls[region.toLowerCase()]}${endpoints.lisa.feedback}`, requestOptions)
    .then(d => {
      if ([200, 201].includes(d.status)) {
        return d.json();
      } else {
        return { errorCode: d.status };
      }
    })
    .then(d => {
      return d;
    })
    .catch(err => {
      console.log(err);
      return err;
    })
}